// Черновите на „Изписване" на началния екран и на таблото — общото
// `components/drafts/useHomeDrafts` с думите и картата на изписването: моето
// незавършено (от сървъра, а до BE без черновите — локалното в този браузър)
// и тези на колегите; заето → „Поеми редакцията". Бързото начало подава вида
// и причината през въпроса за незавършеното (`startNew({ preset })`).
import { useWarehouses } from "../../../../../hooks/useInventory";
import { useHomeDrafts } from "../../../components/drafts/useHomeDrafts";
import { DRAFT_TEXTS } from "../../../components/drafts/draftTexts";
import { WRITEOFF_DRAFT_STORE, localWriteoffDraftSummary } from "../writeoffDraft";

export const WRITEOFF_NEW_PATH = "/inventory/writeoff/new";

export const useWriteoffHomeDrafts = () => {
  const { data: warehouses = [] } = useWarehouses();
  return useHomeDrafts({
    type: "writeoff",
    newPath: WRITEOFF_NEW_PATH,
    local: WRITEOFF_DRAFT_STORE,
    localSummary: (draft) =>
      localWriteoffDraftSummary(
        draft,
        (warehouseId) => warehouses.find((warehouse) => warehouse.id === warehouseId)?.name ?? null,
      ),
    texts: DRAFT_TEXTS.writeoff,
  });
};
